import React, { useState } from 'react';
import '../CSS/Blog.css';

const BlogSection = () => {
  const [zoom, setZoom] = useState(1);



  return (
    <section className="blog-section" id="blog">
      <h2 className="section-title">Our Blog</h2>

    

      <div className="video-container">
        {['video1.mp4', 'video2.mp4', 'video1.mp4'].map((src, index) => (
          <div className="video-wrapper" key={index} style={{ transform: `scale(${zoom})` }}>
            <video
              src={require(`../Assests/videos/${src}`)} // or `/videos/${src}` if in public folder
              controls
              className="video-player"
              title={`Video ${index + 1}`}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default BlogSection;
